import Button from '@/shared/components/button/Button'

interface CancelModalFooterProps {
  onCloseCancelModal: () => void
  onClickCancelConfirmBtn: () => void
  cancelTitle: string
  confirmTitle: string
}

function CancelModalFooter({
  onCloseCancelModal,
  onClickCancelConfirmBtn,
  cancelTitle,
  confirmTitle
}: CancelModalFooterProps) {
  return (
    <div className="flex w-full items-center gap-2">
      <Button color="text090" background="bg020" text={cancelTitle} pyValue="py-[13px]" onClick={onCloseCancelModal} />
      <Button
        color="text010"
        background="bg030"
        text={confirmTitle}
        pyValue="py-[13px]"
        onClick={onClickCancelConfirmBtn}
      />
    </div>
  )
}

export default CancelModalFooter
